import script from "./WorkflowLog.vue?vue&type=script&lang=js"
export * from "./WorkflowLog.vue?vue&type=script&lang=js"

const __exports__ = script;

export default __exports__